<template functional>
    <translate path="Cancellation.cancelable.text" tag="p">
        <template v-slot:pre>
            <strong>
                <translate path="Generic.hint">
                </translate>:
            </strong>
        </template>
        <template v-slot:break>
            <br />
        </template>
        <template v-slot:date>
            <strong>{{props.date}}</strong>
        </template>
    </translate>
</template>

<script>
    export default {
        name: 'CancelableText',
        props: {
            date: String
        }
    }
</script>

